import React, { Component } from "react";
import Table from "../common/table";
import Avatar from "react-avatar";
import { estadosPresupuestos } from "../utils/utils";

class PresupuestosTable extends Component {
  // getSociosString = (socios) => {
  //   let returnString = [];
  //   socios.map((socio, index) => {
  //     returnString.push(
  //       <li key={socio._id} className="list-inline-item">
  //         <Avatar
  //           className="table-avatar"
  //           name={socio.persona.nombre + " " + socio.persona.apellido}
  //           size="40"
  //           round="100%"
  //           src={socio.persona.avatar}
  //         />
  //       </li>,
  //     );
  //   });
  //   return <ul className="list-inline">{returnString}</ul>;
  // };

  getProyecto = (record) => {
    let returnJSX = [];
    returnJSX.push(<a style={{ cursor: "pointer" }}>{record.proyecto ? record.proyecto.nombre : ""}</a>);
    returnJSX.push(<br />);
    returnJSX.push(<small>{record.proyecto ? record.proyecto.ubicacion : ""}</small>);
    return <>{returnJSX}</>;
  };

  getEstado = (record) => {
    const estado = estadosPresupuestos.find((m) => m.value === record.estado);
    let returnJSX = [];
    returnJSX.push(
      <a style={{ cursor: "pointer" }}>
        <span className={"badge " + estado.class}>{record.estado}</span>
      </a>,
    );
    return <>{returnJSX}</>;
  };

  columns = [
    {
      content: (record) => record.descripcion,
      sort: (item) => item.nombre.toLowerCase(),
      label: "Descripcion",
      width: "30%",
      key: Math.random(),
      onClick: (record) => this.props.onView(record._id),
    },
    {
      path: null,
      label: "Proyecto",
      sort: (item) => (item.proyecto ? item.proyecto.nombre : ""),
      key: Math.random(),
      width: "30%",
      content: (item) => this.getProyecto(item),
      onClick: (record) => this.props.onView(record._id),
    },
    {
      content: (record) => record.contratista.nombre + " " + record.contratista.apellido,
      sort: (item) => item.nombre.toLowerCase(),
      label: "Contratista",
      width: "30%",
      key: Math.random(),
      onClick: (record) => this.props.onView(record._id),
    },
    {
      path: null,
      label: "Estado",
      sort: (item) => item.estado,
      key: Math.random(),
      width: "10%",
      content: (item) => this.getEstado(item),
      onClick: (record) => this.props.onView(record._id),
    },
    {
      key: "edit",
      content: (record) =>
        this.props.permisos.canModify ? (
          <i className="fa fa-edit clickable" aria-hidden="true" onClick={() => this.props.onEdit(record._id)}></i>
        ) : (
          ""
        ),
      isicon: true,
      onClick: (record) => this.props.onEdit(record._id),
      dataClass: "text-olive-disabled",
    },
    {
      key: "delete",
      content: (record) =>
        this.props.permisos.canDelete ? (
          <i
            className="fas fa-trash-alt clickable"
            aria-hidden="true"
            onClick={() => this.props.onDelete(record._id)}
          ></i>
        ) : (
          ""
        ),
      isicon: true,
      onClick: (record) => this.props.onDelete(record._id),
      dataClass: "text-danger-disabled",
    },
  ];

  render() {
    const { records, sortColumn, onSort } = this.props;

    return (
      <Table
        data={records}
        columns={this.columns}
        fullClass="table table-striped table-hover mt-2"
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default PresupuestosTable;
